export default __webpack_public_path__ + "static/CloudKitchens_Explainer-b0a15062598c136752e6bfc4d8db91dd.mp4";